/* tslint:disable */
/* eslint-disable */
/**
 * Oasisscan API
 * https://github.com/bitcat365/oasisscan-backend#readme https://api.oasisscan.com/mainnet/swagger-ui/#/ https://api.oasisscan.com/mainnet/v2/api-docs 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DelegationRow
 */
export interface DelegationRow {
    /**
     * 
     * @type {string}
     * @memberof DelegationRow
     */
    validatorAddress: string;
    /**
     * 
     * @type {string}
     * @memberof DelegationRow
     */
    shares: string;
    /**
     * 
     * @type {string}
     * @memberof DelegationRow
     */
    amount: string;
    /**
     * 
     * @type {boolean}
     * @memberof DelegationRow
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof DelegationRow
     */
    validatorName: string | null;
    /**
     * 
     * @type {string}
     * @memberof DelegationRow
     */
    icon: string | null;
    /**
     * 
     * @type {object}
     * @memberof DelegationRow
     */
    entityAddress: object | null;
}

export function DelegationRowFromJSON(json: any): DelegationRow {
    return DelegationRowFromJSONTyped(json, false);
}

export function DelegationRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): DelegationRow {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'validatorAddress': json['validatorAddress'],
        'shares': json['shares'],
        'amount': json['amount'],
        'active': json['active'],
        'validatorName': json['validatorName'],
        'icon': json['icon'],
        'entityAddress': json['entityAddress'],
    };
}

export function DelegationRowToJSON(value?: DelegationRow | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'validatorAddress': value.validatorAddress,
        'shares': value.shares,
        'amount': value.amount,
        'active': value.active,
        'validatorName': value.validatorName,
        'icon': value.icon,
        'entityAddress': value.entityAddress,
    };
}


